<template>
  <div class="flex flex-col gap-3">
    <div v-for="(level, index) in levels" :key="index" class="flex flex-col gap-1">
      <label class="font-semibold">{{ level.label }}</label>
      <Multiselect
        v-model="level.inputValue"
        :options="level.options"
        :canClear="true"
        @change="handleSelect($event, index)"
        @clear="clearAfter(index)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import Multiselect from '@vueform/multiselect';
import { useFilterStore } from '@/store/filterStore.js';
import { getNestedSelectValues } from '@/helpers/nestedSelectCache';

const props = defineProps({
  label: { type: String, required: true },
  name: { type: String, required: true },
  property: { type: Number, required: true },
  dataType: { type: Number, required: true },
});

const filterStore = useFilterStore();
const levels = ref([]);
const fullOptions = ref([]);

const fetchOptions = async () => {
  try {
    const res = await getNestedSelectValues(props.property);
    fullOptions.value = res;
  } catch (e) {
    console.warn('Failed to fetch nested options:', e);
  }
};

const buildLevel = (label, options, initialValue = null) => {
  return reactive({
    label,
    options: options.map(opt => ({
      value: opt.id,
      label: opt.name,
      children: opt.children,
    })),
    inputValue: initialValue,
  });
};

const handleSelect = (value, index) => {
  // Обрезаем уровни после текущего
  levels.value.splice(index + 1);

  const selectedLevel = levels.value[index];
  const selectedOption = selectedLevel.options.find(opt => opt.value === value);

  if (selectedOption?.children?.length) {
    const nextLevel = buildLevel(selectedOption.label, selectedOption.children);
    levels.value.push(nextLevel);
  }

  filterStore.updateFilter({
    type: 'nested',
    property: props.property,
    value,
  });

  filterStore.fetchDynamicCount();
};

const clearAfter = index => {
  levels.value.splice(index + 1);
  filterStore.updateFilter({
    type: 'nested',
    property: props.property,
    value: null,
  });
  filterStore.fetchDynamicCount();
};

onMounted(async () => {
  await fetchOptions();
  if (fullOptions.value.length) {
    const initial = buildLevel(props.label, fullOptions.value);
    levels.value = [initial];
  }
});
</script>

<style scoped>
@import '@vueform/multiselect/themes/tailwind.css';
</style>
